<template>
  <CurrentEventDataProvider v-slot="{ data, features }">
    <SponsorsDataProvider v-if="features.lobbySponsors">
      <CategoriesDataProvider v-slot="{ sponsorsCategories }">
        <div :id="id" class="sponsors-container anchor">
          <div class="mx-auto max-w-large">
            <tappin-sponsors
              ref="sponsorsWc"
              colorScheme="primary"
              :perPage="12"
              :caption="options.label || data.captions.sponsorsCaption"
              :filters="options.isSearchEnabled && features.sponsorFilter"
              :categories="JSON.stringify(sponsorsCategories)"
            >
            </tappin-sponsors>
          </div>
        </div>
      </CategoriesDataProvider>
    </SponsorsDataProvider>
  </CurrentEventDataProvider>
</template>

<script>
import { mapGetters } from 'vuex';
import SponsorInfoModal from '@/components/SponsorInfoModal';
import { getPusherInstance } from '@/utils';

export default {
  props: {
    options: Object,
    id: String
  },
  data() {
    return {
      open: false,
      translations: {
        search_companies: this.$t('Components.Filters.searchPlaceholder'),
        categories: this.$t('Components.Filters.categories'),
        sort_by: this.$t('Components.Filters.sortBy'),
        name: this.$t('Components.Filters.name'),
        order: this.$t('Components.Filters.order'),
        out_of: this.$t('Views.Lobby.SponsorSection.outof')
      },
      sponsorsElement: null
    };
  },
  created() {
    // Live sponsor updates (admin add/edit/delete) — refresh the store so
    // the DataProvider slot re-renders without a manual reload.
    getPusherInstance({ isReady: true }).bind('sponsor-change', () => {
      this.$store.dispatch('Sponsors/refresh');
    });
  },
  mounted() {
    this.sponsorsElement = this.$refs.sponsorsWc;

    if (!this.sponsorsElement) {
      console.error(`sponsorsElement was not found`);
      return;
    }
    this.sponsorsElement.designStyles = this.getWebComponentStyles;
    this.sponsorsElement.translations = this.translations;
    this.sponsorsElement.sponsors = this.filteredSponsors;
    this.sponsorsElement.addEventListener('sponsorClick', (e) => {
      const sponsor = e.detail?.sponsor;
      if (!sponsor) return;
      // Open the themed info modal so the user sees all admin-supplied
      // sponsor info (logo, description, contact, website) without
      // navigating away from the lobby.
      this.openSponsorModal(sponsor);
    });
  },
  methods: {
    openSponsorModal(sponsor) {
      document.body.classList.add('overflow-hidden');
      this.$modal.show(
        SponsorInfoModal,
        { sponsor },
        {
          width: '92%',
          height: 'auto',
          adaptive: true,
          minWidth: 300,
          maxWidth: 640
        },
        { closed: () => document.body.classList.remove('overflow-hidden') }
      );
    }
  },
  watch: {
    filteredSponsors(newFiltered) {
      if (this.sponsorsElement) {
        this.sponsorsElement.sponsors = newFiltered;
      }
    }
  },
  computed: {
    ...mapGetters('CurrentEvent', ['getWebComponentStyles']),
    ...mapGetters('Sponsors', { sponsors: 'getItems' }),
    ...mapGetters('CurrentEvent', ['features']),

    filteredSponsors() {
      if (!this.sponsors?.length) return [];
      if (!this.features.multipleSponsorsEnabled) return this.sponsors;
      if (!this.options?.dropdown) return this.sponsors;

      return this.sponsors.filter((s) =>
        s.sponsorCategories?.some((cat) => cat === this.options?.dropdown)
      );
    }
  }
};
</script>
<style scoped lang="scss">
.sponsors-container {
  background-color: var(--color-primary-bg);
}
</style>
